import { FC } from "react";
import { Nav } from "./Nav";

const Header: FC = () => {
	return (
	  <header className="header">		
	    	<Nav></Nav>
	  </header>
	);
      };
      
export { Header };